/* Stylofer product page: gallery, variant picker, stock, sticky bar, size guide, coupon copy, delivery ETA */
(function () {
  if (!customElements.get('sty-gallery')) {
    customElements.define('sty-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('.sty-pdp__slide')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.count = this.querySelector('[data-count]');
        this.index = 0;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(+t.dataset.thumb)));
        let timer;
        this.track.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
            if (i !== this.index) { this.index = i; this.mark(); }
          }, 60);
        }, { passive: true });
      }
      go(i) {
        const n = this.slides.length; if (!n) return;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'smooth' });
        this.mark();
      }
      goToMedia(id) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId == id);
        if (i > -1) this.go(i);
      }
      mark() {
        if (this.count) this.count.textContent = (this.index + 1) + ' / ' + this.slides.length;
        this.thumbs.forEach((t, k) => t.toggleAttribute('aria-current', k === this.index));
        this.thumbs[this.index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const cfg = JSON.parse(root.querySelector('[data-config]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    const idInput = root.querySelector('[data-variant-id]');
    const fieldsets = [...root.querySelectorAll('[data-option-index]')];
    const atc = root.querySelector('[data-atc]');
    const atcLabel = root.querySelector('[data-atc-label]');
    const buyNow = root.querySelector('[data-buynow]');
    const stock = root.querySelector('[data-stock]');
    const gallery = root.querySelector('sty-gallery');
    const wa = root.querySelector('[data-wa]');
    const err = root.querySelector('[data-error]');
    let current = variants.find((v) => v.id == idInput.value) || variants[0];

    const selected = () => fieldsets.map((fs) => (fs.querySelector('input[data-option]:checked') || {}).value);

    function markAvailability() {
      const sel = selected();
      fieldsets.forEach((fs, oi) => {
        fs.querySelectorAll('input[data-option]').forEach((inp) => {
          const ok = variants.some((v) => v.available && v.options[oi] === inp.value &&
            v.options.every((o, k) => k === oi || sel[k] === undefined || o === sel[k]));
          inp.closest('.sty-opt__pill').classList.toggle('is-out', !ok);
        });
        const val = fs.querySelector('input[data-option]:checked');
        const out = fs.querySelector('[data-option-value]');
        if (out && val) out.textContent = oi === cfg.sizeIndex ? val.value.split('/')[0].trim() : val.value;
      });
    }

    function render(v) {
      const set = (sel, txt, show) => root.querySelectorAll(sel).forEach((el) => { if (txt !== null) el.textContent = txt; if (show !== undefined) el.hidden = !show; });
      if (!v) {
        atc.disabled = true; buyNow.disabled = true; atcLabel.textContent = 'Unavailable';
        stock.textContent = ''; return;
      }
      idInput.value = v.id;
      set('[data-price]', v.price);
      set('[data-sticky-price]', v.price);
      set('[data-compare]', v.compare || '', !!v.compare);
      set('[data-save]', 'Save ' + v.off + '%', v.off > 0);
      set('[data-sale-pill]', null, v.off > 0);
      atc.disabled = !v.available; buyNow.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      stock.className = 'sty-stock';
      if (!v.available) { stock.textContent = 'Sold out in this size'; stock.classList.add('is-out'); }
      else if (v.qty !== null && v.qty > 0 && v.qty <= cfg.low) { stock.textContent = 'Only ' + v.qty + ' left in this size'; stock.classList.add('is-low'); }
      else { stock.textContent = 'In stock — ready to ship'; stock.classList.add('is-in'); }
      if (v.media && gallery && gallery.goToMedia) gallery.goToMedia(v.media);
      if (wa) {
        const msg = 'Assalam o Alaikum! I want to order: ' + cfg.title + ' — Size: ' + v.title + ' — ' + cfg.url + '?variant=' + v.id;
        wa.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(msg);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }

    fieldsets.forEach((fs) => fs.addEventListener('change', () => {
      const sel = selected();
      current = variants.find((v) => v.options.every((o, k) => o === sel[k]));
      if (err) err.hidden = true;
      markAvailability(); render(current);
    }));

    // Quantity
    const qty = root.querySelector('.sty-qty__input');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.value = (+qty.value || 1) + 1; });

    form?.addEventListener('submit', (e) => {
      if (!current || !current.available) { e.preventDefault(); if (err) { err.textContent = 'Please choose an available size.'; err.hidden = false; } }
    });

    // Sticky bar
    const sticky = root.querySelector('[data-sticky]');
    const stickyBtn = root.querySelector('[data-sticky-btn]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', () => {
        if (current && current.available) atc.click();
        else root.querySelector('[data-option-index]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Size guide
    const dlg = root.querySelector('[data-size-guide]');
    root.querySelectorAll('[data-size-guide-open]').forEach((b) => b.addEventListener('click', () => dlg?.showModal()));
    root.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dlg.close());
    dlg?.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });

    // Coupon copy
    root.querySelectorAll('[data-copy]').forEach((b) => b.addEventListener('click', () => {
      navigator.clipboard?.writeText(b.dataset.copy).then(() => { b.textContent = 'Copied ✓'; setTimeout(() => (b.textContent = 'Copy'), 2000); });
    }));

    // Delivery ETA (working days, skipping Sundays)
    const eta = root.querySelector('[data-eta] span');
    const m = String(cfg.days || '3-5').match(/(\d+)\D+(\d+)/);
    if (eta && m) {
      const add = (n) => { const d = new Date(); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; } return d; };
      const f = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      eta.innerHTML = 'Order today — get it between <strong>' + f(add(+m[1])) + '</strong> and <strong>' + f(add(+m[2])) + '</strong>';
    }

    markAvailability(); render(current);
  }

  const run = () => document.querySelectorAll('.sty-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
